import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {UserRole} from '../../types/userrole/user-role';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BaseRestService} from '../common/BaseRestService';
import {SystemType} from '../../types/common/system-type';

@Injectable()
export class UserRolesRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('userroles');
  }

  getAllUserRoles(type: SystemType): Observable<UserRole[]> {
    const params = new HttpParams().set('type', SystemType[type]);
    return this.http.get<UserRole[]>(this.getEndpoint(), {params});
  }

  getAvailableUserRoles(regionId: number, organizationId: number): Observable<UserRole[]> {
    const params = new HttpParams()
      .set('regionId', String(regionId || ''))
      .set('organizationId', String(organizationId || ''));

    return this.http.get<UserRole[]>(this.getEndpoint(['assignable']), {params});
  }

  getPermissionsFor(userRoleId: number): Observable<any> {
    return this.http.get(this.getEndpoint([String(userRoleId), 'permissions']));
  }

  updateUserRolePermissions(userRoleId: number, permissions: string[]): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.put(this.getEndpoint([String(userRoleId), 'permissions']), permissions, {headers});
  }
}
